export const INSTITUTIONS = [
  {
    'pk': 1,
    'name': 'AMDM-ASISTENCIAL MEDICA DE MALDONADO'
  },
  {
    'pk': 2,
    'name': 'AMEDRIM'
  },
  {
    'pk': 3,
    'name': 'AMSJ- ASOCIACIÓN MÉDICA DE SAN JOSE'
  },
  {
    'pk': 4,
    'name': 'ASOCIACIÓN ESPAÑOLA'
  },
  {
    'pk': 5,
    'name': 'ASSE'
  },
  {
    'pk': 6,
    'name': 'BLUE CROSS & BLUE SHIELD'
  },
  {
    'pk': 7,
    'name': 'CAAMEPA'
  },
  {
    'pk': 8,
    'name': 'CAMCEL'
  },
  {
    'pk': 9,
    'name': 'CAMDEL'
  },
  {
    'pk': 10,
    'name': 'CAMEC'
  },
  {
    'pk': 11,
    'name': 'CAMEDUR'
  },
  {
    'pk': 12,
    'name': 'CAMOC'
  },
  {
    'pk': 13,
    'name': 'CAMS'
  },
  {
    'pk': 14,
    'name': 'CAMY'
  },
  {
    'pk': 15,
    'name': 'CASA DE GALICIA'
  },
  {
    'pk': 16,
    'name': 'CASMER'
  },
  {
    'pk': 17,
    'name': 'CASMU'
  },
  {
    'pk': 18,
    'name': 'CENTRO HOSPITALARIO PEREIRA ROSSELL'
  },
  {
    'pk': 19,
    'name': 'CENTRO MÉDICO DE SALTO'
  },
  {
    'pk': 20,
    'name': 'CIRCULO CATÓLICO'
  },
  {
    'pk': 21,
    'name': 'COMECA'
  },
  {
    'pk': 22,
    'name': 'COMEF'
  },
  {
    'pk': 23,
    'name': 'COMEFLO'
  },
  {
    'pk': 24,
    'name': 'COMEPA'
  },
  {
    'pk': 25,
    'name': 'COMERO'
  },
  {
    'pk': 26,
    'name': 'COMMETT'
  },
  {
    'pk': 27,
    'name': 'COMTA'
  },
  {
    'pk': 28,
    'name': 'COSEM'
  },
  {
    'pk': 29,
    'name': 'CRAME'
  },
  {
    'pk': 30,
    'name': 'CRAMI'
  },
  {
    'pk': 31,
    'name': 'CUDAM'
  },
  {
    'pk': 32,
    'name': 'DIRECCIÓN DE ASUNTOS SOCIALES'
  },
  {
    'pk': 33,
    'name': 'DIRECCIÓN NACIONAL DE SANIDAD DE LAS FFAA'
  },
  {
    'pk': 34,
    'name': 'GREMCA'
  },
  {
    'pk': 35,
    'name': 'GREMEDA'
  },
  {
    'pk': 36,
    'name': 'HOSPITAL BRITÁNICO'
  },
  {
    'pk': 37,
    'name': 'HOSPITAL DE CLINICAS'
  },
  {
    'pk': 38,
    'name': 'HOSPITAL EVANGÉLICO'
  },
  {
    'pk': 39,
    'name': 'IAC - INSTITUTO ASISTENCIAL COLECTIVO'
  },
  {
    'pk': 40,
    'name': 'MEDICARE'
  },
  {
    'pk': 41,
    'name': 'MÉDICA URUGUAYA'
  },
  {
    'pk': 42,
    'name': 'MP - MEDICINA PERSONALIZADA'
  },
  {
    'pk': 43,
    'name': 'SEGURO AMERICANO'
  },
  {
    'pk': 44,
    'name': 'SEMM MAUTONE'
  },
  {
    'pk': 45,
    'name': 'SMI - SERVICIO MÉDICO INTEGRAL'
  },
  {
    'pk': 46,
    'name': 'SUMMUM'
  },
  {
    'pk': 47,
    'name': 'UNIVERSAL'
  },
]